import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import AddCircle from '@mui/icons-material/AddCircle';
import STRING_KEYS from '../../../../language/keys';

type AddButtonProps = {
    disabled: boolean,
    onClick: () => void,
}

const AddButton = ({ disabled, onClick }:AddButtonProps): JSX.Element => {
  const { t: translate } = useTranslation();

  return (
    <Button
      size="large"
      startIcon={ <AddCircle color={ disabled ? 'disabled' : 'primary' } /> }
      onClick={ onClick }
      disabled={ disabled }
    >{translate(STRING_KEYS.ADD_ANOTHER)}
    </Button>
  );
};

export default AddButton;
